import { render, staticRenderFns } from "./useragreement-add-or-update.vue?vue&type=template&id=27d5b404&"
import script from "./useragreement-add-or-update.vue?vue&type=script&lang=js&"
export * from "./useragreement-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports